import { Component } from '@angular/core';
import { ProductMenuFooterComponent } from '../product-menu-footer.component';

@Component({
  selector: 'app-menu-footer-oval-boarder',
  templateUrl: './menu-footer-oval-boarder.component.html',
  standalone: false
})
export class MenuFooterOvalBoarderComponent extends ProductMenuFooterComponent {}
